import React from 'react'
import {
    StyledColumn,
    PlaceholderContainer,
    StyledImageContainer,
    StyledText,
    StyledTitle,
} from './EditionPlaceholder.styled'

export const EditionPlaceholder: React.FC<{
    type: 'homepage' | 'editions'
    lazyloadImages?: boolean
}> = ({ type, lazyloadImages }) => {
    const mobileImage = require<string>('./assets/TN-comingSoon.png')

    return (
        <PlaceholderContainer type={type}>
            <StyledColumn>
                <StyledTitle>Coming soon</StyledTitle>
                <StyledText>
                    {'The Nightly\u2019s first Digital Newspaper.'}
                    <br />
                    6PM AEDT Tonight.
                </StyledText>
            </StyledColumn>
            <StyledColumn>
                <StyledImageContainer
                    src={mobileImage}
                    alt={
                        'Coming Soon, The Nightly\u2019s first Digital Newspaper'
                    }
                    loading={lazyloadImages ? 'lazy' : undefined}
                />
            </StyledColumn>
        </PlaceholderContainer>
    )
}

export default EditionPlaceholder
